module.exports = __webpack_public_path__ + "img/undraw_online_dating_yruf.15ebb8b2.svg";